import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { WarningDialogComponent } from 'src/app/shared/dialogs/warning-dialog/warning-dialog.component';
import packageJson from 'package.json';

@Component({
  selector: 'app-layout-register-client',
  templateUrl: './layout-register-client.component.html',
  styleUrls: ['./layout-register-client.component.scss'],
})
export class LayoutRegisterClientComponent {
  currentStep: number;
  version: string;
  constructor(private dialog: MatDialog) {
    this.currentStep = 1;
    this.dialog.open(WarningDialogComponent, {
      width: '60%',
      disableClose: true,
      data: {
        title: 'Quiero ser Cliente de Coca-Cola Andina.',
        message:
          'En el siguiente formulario solicitaremos todos los datos necesarios de tu comercio para que puedas operar con nuestros productos',
        message2:
          'Si ya sos cliente y lo que necesitas es gestionar tu usuario WEB/APP de MiCocaCola, volve hacia atrás e ingresar en la opción correcta.',
      },
    });
    this.version = packageJson.version
    console.log('version',packageJson.version)
  }

  backForm() {
    this.currentStep--;
  }

  changeForm(event: number) {
    this.currentStep = event;
  }
}
